export const downloadModifiedPdf = async (pdfBytes, fileName) => {
    const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });

    const pdfUrl = URL.createObjectURL(pdfBlob);

    const a = document.createElement("a");
    a.href = pdfUrl;
    a.download = `${fileName}.pdf`; // Set the desired file name

    a.click();

    URL.revokeObjectURL(pdfUrl);
  };

  export async function loadTtfFont(path) {
    const response = await fetch(path); // Replace with the correct font file path
    const arrayBuffer = await response.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);
    return uint8Array;
  }